import { Box, FormControlLabel, Stack, Typography } from "@mui/material";
import DialogCustom from "components/DialogCustom";
import Scrollbar from "components/Scrollbar";
import { useState } from "react";

import { Trans, useTranslation } from "react-i18next";
import { ListSectionVertical } from "./components";
import { listFeature, navList } from "../config/byFeature";
import { styled } from "@mui/material/styles";
import ReactGA from "react-ga4";
import useRole from "state/useRole";
import { Checkbox } from "@mui/material";
import { KeyWhatIsNewType } from "state/useFlag";

type WhatIsNewByFeatureProps = {
  open: boolean;
  onClose: () => any;
  onCloseShowAgain: () => any;
  feature: KeyWhatIsNewType;
  keyFristView?: any;
};

const WhatIsNewByFeature = ({
  open,
  onClose,
  onCloseShowAgain,
  feature,
  keyFristView,
}: WhatIsNewByFeatureProps) => {
  const { isFeature } = useRole();
  const { t } = useTranslation(["translation", "newFeature"]);
  const [checkedNotShowAgain, setCheckedNotShowAgain] = useState(false);
  const list = navList(t, isFeature)
    .filter((obj) => {
      if (Array.isArray(obj.key)) {
        return obj.key.includes(feature);
      } else {
        return obj.key === feature;
      }
    })
    .filter((obj) => !obj?.isHidden);
  // const idFromFeature = navList(t, isFeature).find((item) => item?.toGetKeyNumber === feature)?.id || 6;
  // const [isActive, setIsActive] = useState(
  //   keyFristView ? list.find(({ id }) => id === keyFristView)?.id : list[0]?.id
  // );
  const [isActive, setIsActive] = useState(
    navList(t, isFeature).find((item) => item?.toGetKeyNumber === feature)?.id || 6
  );
  const contentActive = listFeature(t)[`${isActive}`];
  const onHandleActive = (id) => {
    ReactGA.event("what_is_new_by_feature", {
      user_interaction: "select menu",
      event_value: id,
    });
    setIsActive(id);
  };

  const handleClose = () => {
    if (checkedNotShowAgain) {
      ReactGA.event("what_is_new_by_feature", {
        user_interaction: "close not show again",
      });
      onCloseShowAgain();
    } else {
      ReactGA.event("what_is_new_by_feature", {
        user_interaction: "close",
      });
      onClose();
    }
  };
  return (
    <DialogCustom open={open} handleClose={handleClose}>
      <Stack direction={{ xs: "column", sm: "row" }} spacing="36px" alignItems="flex-start">
        <Scrollbar
          sx={{
            height: "400px",
            width: { xs: "100%", sm: 236, lg: 296 },
            background: "#EEEEEE",
            borderRadius: "4px",
          }}
        >
          <Box
            sx={{
              p: "12px",
              pr: "20px",
            }}
          >
            <ListSectionVertical
              active={isActive}
              handleActive={onHandleActive}
              listConfig={list}
            />
          </Box>
        </Scrollbar>
        <Scrollbar sx={{ height: "400px", width: "100%" }}>
          <Stack spacing="24px" sx={{ pr: "16px" }}>
            <Stack direction="row" gap="16px" alignItems="center" flexWrap={"wrap"}>
              <Trans>
                <Typography variant="h5">{contentActive.title}</Typography>
              </Trans>
              {contentActive.type && <BoxVersion>New Feature</BoxVersion>}
            </Stack>
            {contentActive.image && <Image src={contentActive.image} alt="" />}
            <Trans>
              <BoxContent>
                <Stack spacing="24px">{contentActive.content}</Stack>
              </BoxContent>
            </Trans>
          </Stack>
        </Scrollbar>
      </Stack>
      <Stack alignItems="center" mt={3}>
        <FormControlLabel
          control={
            <Checkbox
              checked={checkedNotShowAgain}
              onChange={(event) => setCheckedNotShowAgain(event.target.checked)}
              size="small"
            />
          }
          label={
            <Typography variant="body3" color="text.secondary">
              {t("do not show this page again")}
            </Typography>
          }
        />
      </Stack>
    </DialogCustom>
  );
};

export default WhatIsNewByFeature;

const BoxVersion = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid ${(props) => props.theme.palette.warning.main};
  box-sizing: border-box;
  border-radius: 8px;
  color: ${(props) => props.theme.palette.warning.main};
  padding: 4px 10px;
  font-size: 0.875rem;
  font-weight: 600;
  height: 25px;
`;

export const Image = styled("img")`
  max-width: 360px;
  width: 100%;
  object-fit: cover;
`;

const BoxContent = styled(Box)`
  color: ${(props) => props.theme.palette.text.secondary};
  line-height: 143%;
  & strong {
    color: ${(props) => props.theme.palette.primary.main};
  }
  white-space: pre-line;
`;
